import React, { useState, useContext, useEffect } from "react";
import { Controller } from "react-hook-form";
import { IonLabel, IonItem, IonRadio, IonRadioGroup } from "@ionic/react";
import { useIntl } from "react-intl";
import RestrictedContext from "../util/RestrictedContext";
import SkeltonItemContent from "./SkeltonItemContent";

const RadioButtonItem = (props) => {
  const {
    name,
    control,
    rules,
    label,
    disabled,
    type,
    category,
    params,
    color,
    identfierId,
    trueFalse,
    visitsStrategy,
    genders,
    translated,
    loading,
    ...rest
  } = props;

  const intl = useIntl();
  const restricted = useContext(RestrictedContext);
  const [selectData, setSelectData] = useState([]);
  // const allGenders = useGenders();
  useEffect(() => {
    let list = null;
    if (genders) {
      list = [];
    } else if (visitsStrategy) {
      list = [
        {
          id: "professional",
          name: "professionalEmployee",
        },
        {
          id: "controller",
          name: "controller",
        },
        {
          id: "alternate",
          name: "alternately",
        },
      ];
    } else if (trueFalse) {
      list = [
        {
          id: true,
          name: "yes",
        },
        {
          id: false,
          name: "no",
        },
      ];
    }

    if (list && selectData.length === 0) {
      setSelectData(list);
    }
  }, [genders, selectData.length, trueFalse, visitsStrategy]);
  const identfier = identfierId ? identfierId : "name";
  return loading ? (
    <IonItem>
      <SkeltonItemContent />
    </IonItem>
  ) : (
    <IonItem>
      <IonLabel position="stacked">{label}</IonLabel>
      <Controller
        control={control}
        rules={rules}
        render={({ field }) => {
          const { onChange, onBlur, value } = field;
          return (
            <IonRadioGroup
              {...rest}
              value={value}
              onIonChange={(e) => {
                return onChange(e.detail.value);
              }}
              onBlur={onBlur}
              style={{ display: "flex" }}
            >
              {selectData.map((option) => (
                <IonItem key={option[identfier]} lines="none">
                  <IonLabel>
                    {translated
                      ? intl.formatMessage({
                          id:
                            "app.mobile.dataSelect." + name + "." + option.name,
                        })
                      : trueFalse
                      ? intl.formatMessage({
                          id: "app.mobile.dataSelect." + option.name,
                        })
                      : option.name}
                  </IonLabel>
                  <IonRadio
                    color={color ? color : "primary"}
                    slot="start"
                    value={option.id}
                    mode="md"
                    disabled={disabled || !restricted["hasWritePermission"]}
                  />
                </IonItem>
              ))}
            </IonRadioGroup>
          );
        }}
        name={name}
      />
    </IonItem>
  );
};

export default RadioButtonItem;
